import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  inject,
  SecurityContext, OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule, SECURITY_CONTEXT } from 'ngx-markdown';
import { Tooltip } from 'primeng/tooltip';
import { trigger, transition, style, animate } from '@angular/animations';
import { ClipboardService } from '@brighthub/utils';
import { Message } from '../../models/copilot.models';
import { ChatMessageTraceComponent } from '../chat-message-trace/chat-message-trace.component';
import { ButtonDirective } from 'primeng/button';
import { ChatMessageFeedbackComponent } from '../chat-message-feedback/chat-message-feedback.component';

@Component({
  selector: 'lib-chat-message',
  imports: [
    CommonModule,
    MarkdownModule,
    Tooltip,
    ChatMessageTraceComponent,
    ButtonDirective,
    ChatMessageFeedbackComponent,
  ],
  providers: [
    {
      provide: SECURITY_CONTEXT,
      useValue: SecurityContext.HTML,
    },
  ],
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss'],
  animations: [
    trigger('messageAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(8px)' }),
        animate(
          '200ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessageComponent {


  private _clipboard = inject(ClipboardService);



  @Input() message!: Message;
  @Input() copilotName = 'BrightAI';
  @Input() userDisplayName = 'User';
  @Input() userInitials = 'U';
  @Output() scrollDown = new EventEmitter<string>();
  @Input() hideFeedback!: boolean;

  copyToClipboard(text: string): void {
    this._clipboard.copy(text);
  }

  scrollToBottom(behavior: 'smooth' | 'auto' = 'smooth'): void {
    this.scrollDown.emit(behavior);
  }

}

